import { render, staticRenderFns } from "./add_acount.vue?vue&type=template&id=8f56fe1c&scoped=true"
import script from "./add_acount.vue?vue&type=script&lang=js"
export * from "./add_acount.vue?vue&type=script&lang=js"
import style0 from "./add_acount.vue?vue&type=style&index=0&id=8f56fe1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f56fe1c",
  null
  
)

export default component.exports